export default "/assets/images/technology-hero.jpg?80c91ebde4824c304a3132bd4fd9fc3a";